import React from "react";
import { Badge } from "reactstrap";

function TrendBadge({ value }) {
  // Handle null or undefined values
  if (value === null || value === undefined) {
    return (
      <Badge color="warning" pill className="outline">
        <span>N/A</span>
      </Badge>
    );
  }

  // Handle positive/negative values
  const variant = value == 0 ? "info" : value > 0 ? "success" : "danger";
  const icon = value == 0 ? "fa-minus" : value > 0 ? "fa-arrow-up" : "fa-arrow-down";

  return (
    <Badge color={variant} pill className="outline">
      <i className={`fa ${icon}`} style={{ fontSize: "10px" }} />
      <span style={{ paddingLeft: "4px" }}>{Math.abs(value)}%</span>
    </Badge>
  );
}

export default TrendBadge;
